<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Emergency Service</h3>
            <p class="depth bullet03">Medical service is available 24/7 irrespective of holidays for emergency (child delivery) patients.</p>
            <p class="depth bullet03">To prepare for medical care of emergency patients around the clock, our hospital is equipped with emergency medical equipment, staffed with professionals, and making best efforts to provide prompt emergency service.</p>
            <p class="depth bullet03">Emergency patients will directly receive medical care in our emergency room regardless of the healthcare delivery system (no need to come after visiting primary and secondary medical institutions) and the location.</p>
            <p class="depth bullet03">In the Emergency Center, wireless communication network, emergency medical equipment, ambulance, etc. are on standby 24/7 to minimize a service gap in emergency medical network and during nights and holidays.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Emergency service application</h3>
            <p class="depth">As a patient, when you arrive at the ER, get a preliminary medical check at the room for severity check, apply for a service at the administration office inside the ER, and submit the service application form and health insurance card (medical care certificate) with your ID.</p>
            <p class="depth">Once the administration office issues you an emergency patient name tag and patient bracelet, hand those in to the nurse office.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Emergency service</h3>
            <p class="depth">ER specialist will decide whether to check out or get admitted after a check-up</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Payment for emergency service</h3>
            <p class="depth">Medical fee needs to be paid at once when determined to return home. However, special procedures (MRI, CT scan, ultrasound) will be paid before each procedure.</p>
            <p class="depth">For patients whose health insurance or medical care coverage is not confirmed, the full amount will apply to the patient him/herself.</p>
            <p class="depth">Credit cards can be used for payment.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Check-out and discharge</h3>
            <div class="table">
                <table>
                    <colgroup>
                        <col style="width: 50%;">
                        <col style="width: 50%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Discharge</th>
                            <th>Admission</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Submit the medical invoice to a nurse, receive your medicine, and get information on the next medical schedule, precautions at home before returning home.
                            </td>
                            <td>
                                When you are decided to be hospitalized, receive guidance from the nurse in charge and go through admission process at the emergency application/payment.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>